import Vhost from 'umg-ember-backend/components/record-explorer/for/vhost';

<template><Vhost @records={{@model}} @recordType='vhost' /></template>
